const INPUT_TYPE = {
  MANUAL: 'manual',
  SCANNER: 'scanner',
};

function delayExecution(fn, delay) {
  let timer = null;
  return function debouncedHandler() {
    const context = this;
    const args = arguments;
    clearTimeout(timer);
    timer = window.setTimeout(function runDebouncedHandler() {
      fn.apply(context, args);
    }, delay || 200);
  };
}

/**
 * Resolves shipment input type from key event data.
 * Scanner: single debounced keyup burst ending with Enter (keyFiredCount <= 1).
 * Manual: multiple keyup bursts before Enter, or keyFiredCount > 1 on Enter.
 *
 * @returns {'manual'|'scanner'|null}
 */
function resolveShipmentInputType({ keycode, keyFiredCount, inputValue }) {
  if (inputValue == null || String(inputValue).trim() === '') {
    return null;
  }

  if (keycode === 13) {
    return keyFiredCount <= 1 ? INPUT_TYPE.SCANNER : INPUT_TYPE.MANUAL;
  }

  return keyFiredCount > 1 ? INPUT_TYPE.MANUAL : null;
}

function createShipmentInputDetector(options = {}) {
  const debounceDelay = options.debounceDelay || 200;
  const state = {
    keyFiredCount: 0,
    inputType: null,
  };

  function reset() {
    state.keyFiredCount = 0;
    state.inputType = null;
  }

  function detectInputType(keycode, inputValue) {
    if (inputValue == null || String(inputValue).trim() === '') {
      reset();
      return null;
    }

    state.keyFiredCount += 1;
    const resolvedType = resolveShipmentInputType({
      keycode,
      keyFiredCount: state.keyFiredCount,
      inputValue,
    });

    if (resolvedType) {
      state.inputType = resolvedType;
    }

    if (keycode === 13) {
      state.keyFiredCount = 0;
    }

    return resolvedType;
  }

  function getInputType() {
    return state.inputType || INPUT_TYPE.MANUAL;
  }

  function createDebouncedKeyUpHandler(handler) {
    return delayExecution(handler, debounceDelay);
  }

  return {
    reset,
    detectInputType,
    getInputType,
    createDebouncedKeyUpHandler,
    INPUT_TYPE,
  };
}

function ensureShipmentInputDetector(vm, options = {}) {
  if (!vm.shipmentInputDetector) {
    vm.shipmentInputDetector = createShipmentInputDetector(options);
  }
  return vm.shipmentInputDetector;
}

module.exports = {
  INPUT_TYPE,
  delayExecution,
  resolveShipmentInputType,
  createShipmentInputDetector,
  ensureShipmentInputDetector,
};


// WEBPACK FOOTER //
// ./src/common/shipmentInputTypeHelper.js